<template>
    <div class="pro-pic inner-upload-single">
        <transition-group tag="div" class="drag-wrap">
            <div class="drag-item" v-for="(file,index) in fileListNew" :key="file.url"
                 draggable="true"
                 @dragstart="handleDragStart($event, file)"
                 @dragover.prevent="handleDragOver($event, file)"
                 @dragenter="handleDragEnter($event, file)"
                 @dragend="handleDragEnd($event, file)">
                <div
                    class="file-box"
                    :class="{ borderColorChange:file.url }">
                    <div v-if="file.url">
                       {{file.name}}
                    </div>
                    <div v-if="file.url && !dragging" class="file-cover-wrap" @click.stop="del(index)">
                        删除
                    </div>
                </div>
            </div>
        </transition-group>
        <el-upload
            class="avatar-uploader"
            action="/service-center/upload/file/single"
            :headers="headers"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :on-success="handleAvatarSuccess"
            :on-progress="handleAvatarProgress">
            <el-button>{{buttonName}}</el-button>
        </el-upload>
    </div>
</template>

<script>
    export default {
        name: "uploadMultiImage",
        props: {
            fileList: {
                type: Array,
                default: () => []
            },
            buttonName: {
                type: String,
                default: '点击上传'
            },
            fileType: {
                type: String,
                default: ''
            },
            fileTypeMessage: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                dragging: null,
                fileListNew: [],
                beforeFileList: [],
                headers: {
                    'Authorization': 'Bearer ' +  $cookies.get("api_access_token")
                }
            }
        },
        watch:{
            fileList: {
                handler(val) {
                    if(val){
                        this.fileListNew = val
                    } else {
                        this.fileListNew = []
                    }
                },
                immediate: true,
                deep: true
            },
        },
        computed: {},
        methods: {
            handleAvatarSuccess(res, file) {
                this.fileListNew.push(res)
                this.$emit('fileListChange', this.fileListNew)
            },
            beforeAvatarUpload(file) {
                if(this.fileType){
                    let fileName = file.name.lastIndexOf('.') + 1
                    const fileNameLen = file.name.length
                    const fileTypeName = file.name.substring(fileName, fileNameLen)
                    if(this.fileType.indexOf(fileTypeName) === -1){
                        this.$message.warning(this.fileTypeMessage)
                        return false
                    } else {
                        return true
                    }
                } else {
                    return true
                }
            },
            handleAvatarProgress(event){},
            del(index) {
                this.fileListNew.splice(index,1)
                this.$emit('deleteFile', this.fileListNew)
            },
            handleDragStart(e, item) {
                this.dragging = item
            },
            handleDragEnd(e, item) {
                this.dragging = null
            },
            handleDragOver(e) {
                e.dataTransfer.dropEffect = 'move'
            },
            handleDragEnter(e, item) {
                e.dataTransfer.effectAllowed = "move" //为需要移动的元素设置dragstart事件
                if (item === this.dragging) {
                    return
                }
                const newItems = [...this.fileListNew]
                const src = newItems.indexOf(this.dragging)
                const dst = newItems.indexOf(item)
                newItems.splice(dst, 0, ...newItems.splice(src, 1))
                this.fileListNew = newItems
                this.$emit('getDragFile', newItems)
            }
        }
    }
</script>

<style lang="less" scoped>
    button{
        width: 100px;
        background: #3d7fff;
        border: none;
        border-radius: 5px;
        font-size: 14px;
        color: #FFFFFF;
    }
    .container{
        width: 80px;
        height: 300px;
        position: absolute;
        left: 0;
        display:flex;
        flex-direction: column;
        padding: 0;
    }
    .item {
        margin-top: 10px;
        transition: all linear .3s
    }
    .drag-wrap {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .drag-item {
            margin-bottom: 13px;
            width: 49%;
            height: 55px;
            line-height: 55px;
            padding: 0 20px;
            border: 1px solid #ddd;
            border-radius: 4px;
            &:last-child {
                margin-right: 0;
            }
        }
    }
    .avatar-uploader-icon {
        color: #409eff;
        width: 275px;
        height: 200px;
        text-align: center;
        vertical-align: middle;
        display: table-cell;
        text-align: center;
        font-size: 12px;
        border: 1px dashed #ddd;
    }
    .file-box {
        width: 100%;
        height: 100%;
        float: left;
        margin-right: 13px;
        position: relative;
    }
    
    .file-box:last-child {
        margin-right: 0;
    }
    
    
    .el-icon-plus:before {
        content: "";
    }
    
    // 删除
    .file-cover-wrap {
        right: 0;
        top: 0;
        position: absolute;
        line-height: 55px;
        color: #3d7fff;
        cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/uploadFile/index.vue